import React from 'react';
interface ServicePlanProps {
  title: string;
  price: string;
  description: string;
  imageUrl: string;
  imageAlt: string;
  buttonLink: string;
}
const ServicePlan = ({
  title,
  price,
  description,
  imageUrl,
  imageAlt,
  buttonLink
}: ServicePlanProps) => {
  return <div className="flex flex-col bg-white rounded-lg overflow-hidden shadow-lg transition-transform duration-300 hover:transform hover:scale-105" data-id="element-135">
      <div className="h-48 overflow-hidden" data-id="element-136">
        <img src={imageUrl} alt={imageAlt} className="w-full h-full object-cover" data-id="element-137" />
      </div>
      <div className="p-6 flex flex-col flex-grow" data-id="element-138">
        <h3 className="text-xl font-bold text-[#E57C23] mb-2" data-id="element-139">{title}</h3>
        <p className="text-2xl font-bold text-[#F8B179] mb-4" data-id="element-140">{price}</p>
        <p className="text-gray-600 mb-6 flex-grow" data-id="element-141">{description}</p>
        <a href={buttonLink} className="bg-[#E57C23] text-white py-3 px-6 rounded-md text-center font-medium hover:bg-[#F8B179] transition-colors duration-300" data-id="element-142">
          Get Started
        </a>
      </div>
    </div>;
};
export default ServicePlan;